import React from 'react';
import { StyledModalHeader } from './styles';

export type ModalHeaderProps = React.HTMLAttributes<HTMLDivElement> & { className?: string };

const ModalHeader: React.FC<ModalHeaderProps> = ({ className = '', children, ...otherProps }) => (
    <StyledModalHeader className={`rui-modal-header ${className}`.trim()} {...otherProps}>
        {children}
    </StyledModalHeader>
);

export default ModalHeader;
